import { render, staticRenderFns } from "./DotCmsImage.vue?vue&type=template&id=3d8860ef&"
import script from "./DotCmsImage.vue?vue&type=script&lang=js&"
export * from "./DotCmsImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports